<template>
  <v-container mt-1>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-text>
            <v-container>
              <h2>Enter your authenticator code</h2>
              <p>Open your authenticator app and enter the 6-digit code shown for WebQuote.</p>
              <form @submit.prevent="onSubmit">
                <v-text-field
                  v-model="code"
                  label="6-digit code"
                  maxlength="6"
                  required
                  autofocus
                ></v-text-field>
                <v-alert v-if="mfaError" :value="true" color="error" outline icon="warning">
                  {{ mfaError }}
                </v-alert>
                <v-layout row>
                  <v-flex xs12>
                    <v-btn type="submit" color="primary" :disabled="submittingMfa || code.length !== 6">
                      Verify
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <a
                      href="#"
                      class="mfa-fallback-link"
                      :class="{ 'mfa-fallback-link--disabled': submittingMfa }"
                      @click.prevent="onFallback"
                    >
                      I can't access my authenticator — email me a code instead
                    </a>
                  </v-flex>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import router from '@/router'

export default {
  name: 'mfa-totp',
  data() {
    return { code: '' }
  },
  computed: {
    ...mapGetters('mfa', ['mfaPending', 'mfaMethod', 'submittingMfa', 'mfaError'])
  },
  created() {
    if (!this.mfaPending || this.mfaMethod !== 'totp') {
      router.replace('/login')
    }
  },
  methods: {
    ...mapActions('mfa', ['verify', 'fallbackToEmail']),
    async onSubmit() {
      const ok = await this.verify({ code: this.code })
      if (ok) router.push('/')
    },
    async onFallback() {
      if (this.submittingMfa) return
      const ok = await this.fallbackToEmail()
      if (ok) router.push('/mfa-code')
    }
  }
}
</script>

<style scoped>
.mfa-fallback-link {
  display: inline-block;
  margin-top: 8px;
  color: #1976d2;
  font-size: 14px;
  line-height: 1.4;
  cursor: pointer;
  text-decoration: none;
}
.mfa-fallback-link:hover {
  text-decoration: underline;
}
.mfa-fallback-link--disabled {
  color: rgba(0, 0, 0, 0.38);
  cursor: default;
  pointer-events: none;
}
</style>
